import { Component, OnInit, Inject } from '@angular/core';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'ebb-portal-dialog-submit',
    templateUrl: './dialog-submit.component.html',
    styleUrl: './dialog-submit.component.scss',
    standalone: false
})
export class DialogSubmitComponent implements OnInit {
  public formPermissions: FormGroup;
  public disableGrantSave: boolean;
public isCertified = false;
  constructor(
    public dialogRef: MatDialogRef<DialogSubmitComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly fb: FormBuilder  
  ) { }

  ngOnInit() {
  }

  onClickYes(): void {
    this.data = 'yes';
    this.dialogRef.close(this.data);
  }

  onClickNo(): void {
    this.dialogRef.close();
  }

}
